import { SanityProductControlOption } from './sanity-product-control-option';

export interface SanityProductFilter {
  key: SanityProductFilterKey;
  title: string;
  tooltipText: string;
  options: SanityProductControlOption[];
}

export enum SanityProductFilterKey {
  garmentColor = 'GarmentColor',
  garmentSize = 'GarmentSize',
  garmentPrint = 'GarmentPrint',
  garmentTechnology = 'GarmentTechnology',
  paperFormat = 'PaperFormat',
  orientation = 'Orientation',
  frameColor = 'FrameColor',
  frameAssembling = 'FrameAssembling',
  wallHangerColor = 'WallHangerColor',
  mugmaterial = 'MugMaterial',
  phoneBrand = 'PhoneBrand',
  bagColor = 'BagColor',
  bagSize = 'BagSize',
  bagPrint = 'BagPrint',
  formatSize = 'FormatSize',
  passepartoutcolor = 'PassepartoutColor',
}
